export default __webpack_public_path__ + "static/media/Group-146.923887ef.png";